import { Popover, Table } from "antd";
import { useMemo } from "react";

const ViPhamPopover = ({
    data = []
}: {
    data?: any[];
    }) => {
    const value = data.length;
    const dataSource = useMemo(() => {
        return data.map((item: any, index: number) => ({
            ...item,
            key: item.id || item.key || index
        }));
    }, [data]);

    const columns = [
        {
            title: "STT",
            width: 45,
            align: "center" as const,
            render: (_: any, __: any, index: number) => index + 1
        },
        {
            title: "Họ tên",
            dataIndex: "hoTen",
            width: 180
        },
        {
            title: "Nội dung",
            dataIndex: "noiDung"
        },
        {
            title: "Điểm trừ",
            dataIndex: "diemTru",
            width: 80,
            align: "center" as const,
            render: (value: number) => (
                <span
                    style={{
                        color: "#dc2626",
                        fontWeight: 600
                    }}
                >
                    -{Math.abs(value)}
                </span>
            )
        },
        {
            title: "Ghi chú",
            dataIndex: "ghiChu",
            width: 180
        }
    ];

    return (
        <td
            style={{
                border: '1px solid #e5e7eb',
                padding: '10px 12px',
                textAlign: 'center'
            }}
        >
            <Popover
                trigger="hover"
                placement="left"
                zIndex={10000}
                title={
                    <span style={{ fontWeight: 600 }}>
                        Chi tiết lỗi vi phạm
                    </span>
                }
                content={
                    <div style={{ width: 800 }}>
                        <Table
                            rowKey="key"
                            columns={columns}
                            dataSource={dataSource}
                            pagination={false}
                            size="small"
                            scroll={{ y: 250 }}
                        />
                    </div>
                }
            >
                <span
                    style={{
                        display: 'inline-block',
                        background:
                            value > 0
                                ? '#fef2f2'
                                : '#f3f4f6',
                        color:
                            value > 0
                                ? '#ef4444'
                                : '#9ca3af',
                        borderRadius: '12px',
                        padding: '2px 10px',
                        fontWeight: 600,
                        fontSize: '13px',
                        cursor: 'pointer'
                    }}
                >
                    {value}
                </span>
            </Popover>
        </td>
    );
};

export default ViPhamPopover;